import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    render: function() {
        var content =
        '<h1>Workspace Settings</h1>' +
        '<div class="tab">' +
            '<div class="tab-menu">' +
                '<a class="navigation" href="/account/">' +
                    '<span class="text">General</span>' +
                '</a>' +
                '<a class="navigation" href="/account/billing">' +
                    '<span class="text">Billing</span>' +
                '</a>' +
                '<a class="navigation" href="/account/branding">' +
                    '<span class="text">Branding</span>' +
                '</a>' +
                '<a class="navigation" href="/account/connected_app">' +
                    '<span class="text">Connected Apps</span>' +
                '</a>' +
                '<a class="navigation" href="/account/extension_key">' +
                    '<span class="text">Extension Key</span>' +
                '</a>' +
                '<a class="navigation" href="/account/api_token">' +
                    '<span class="text">API Token</span>' +
                '</a>' +
                (!Cache.account.get('is_trial') ?
                '<a class="navigation" href="/account/referral">' +
                    '<span class="text">Referral Program</span>' +
                '</a>' : '') +
                '<a class="navigation" href="/account/integration_log">' +
                    '<span class="text">Integration Logs</span>' +
                '</a>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        var pathname = window.location.pathname.replace(/\/$/, '');

        this.$el.find('.tab-menu a[href="' + pathname + '"]').addClass('active');
        this.$el.find('.tab-menu a[href="' + pathname + '/"]').addClass('active');

        return this;
    }
});